/* eslint-disable no-duplicate-imports */
import * as React from 'react';
import { ICipLanguagePickerResources } from '../cip-language-picker.props.autogenerated';

export interface IBusinessSignUpDropdownProps {
    id?: string;
    value: string;
    className: string;
    isRequired: boolean;
    options: IBusinessSignUpDropdownOption[];
    onChange: (event: React.ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => void;
    fieldReference?: React.RefObject<HTMLSelectElement>;
    selectValue: IBusinessSignUpDropdownOption;
    isSubmittedPressed: boolean;
    resources: ICipLanguagePickerResources;
}

export interface IBusinessSignUpDropdownOption {
    key: string;
    value: string;
}

export const BusinessSignUpDropdown: React.FC<IBusinessSignUpDropdownProps> = ({
    id,
    isRequired,
    options,
    onChange,
    selectValue,
    isSubmittedPressed,
    resources
}) => {
    const showError = isRequired && isSubmittedPressed && (!selectValue || selectValue.value === '');
    return (
        <div className={`msc-address-form__dropdown-wrapper`}>
            <select
                id={id}
                value={selectValue?.value}
                className={`msc-address-form__dropdown ms-form__dropdown ${selectValue.value === '' && isSubmittedPressed && 'necessary'}`}
                aria-required={isRequired}
                onChange={(event: any) => onChange(event)}
            >
                <option disabled selected value={''}>
                    {resources.select}
                </option>
                {options.map((option: IBusinessSignUpDropdownOption) => {
                    return (
                        <option key={option.key} value={option.value}>
                            {option.value}
                        </option>
                    );
                })}
            </select>

            {showError && (
                <div
                    id={id}
                    className={`cip-language-picker__form-item-item-danger`}
                    role={'alert'}
                    aria-live={'polite'}
                    aria-label={resources.requiredFieldMissingError}
                >
                    <p className='cip-language-picker__form-item-item-danger-text'>{resources.requiredFieldMissingError}</p>
                </div>
            )}
        </div>
    );
};

export default BusinessSignUpDropdown;
